import { render, staticRenderFns } from "./CouponsHistoryTable.vue?vue&type=template&id=58283dc2"
import script from "./CouponsHistoryTable.vue?vue&type=script&lang=js"
export * from "./CouponsHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports